import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { getCurrentBrand } from 'src/Redux/Perimeter/Selectors';
import { RepositoriesService } from 'src/Services/API';
import { MEDICAL_BRAND_CODES } from 'src/Utils/medicalBrandCodes';

import { QueryKeys } from '../types';

export const useFetchMedicalSpecializations = () => {
  const currentBrand = useSelector(getCurrentBrand);
  return useQuery(
    [QueryKeys.fetchMedicalSpecializations, currentBrand],
    async () => {
      if (!currentBrand || !currentBrand.brandCodeApiHeader) {
        return Promise.reject('No current brand or has an invalid current brand');
      }
      return await RepositoriesService.repositoriesControllerGetMedicalSpecializations({
        brandCode: currentBrand.brandCodeApiHeader,
      });
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: MEDICAL_BRAND_CODES.includes(currentBrand?.brandCodeApiHeader ?? ''),
    }
  );
};
